import styled from 'styled-components'
import React from 'react'
import CardBrandLogo from 'obvio/Billing/CreditCardSection/CardBrandLogo'
import {useDefaultPaymentMethod} from 'obvio/Billing/DefaultPaymentMethodProvider'

export default function ExistingCard(props: {className?: string}) {
  const {paymentMethod} = useDefaultPaymentMethod()

  if (!paymentMethod) {
    return null
  }

  const {card, billing_details: billingDetails} = paymentMethod
  const nameOnCard = billingDetails?.name

  return (
    <div className={props.className}>
      <Card>
        <Brand>
          <CardBrandLogo brand={card?.brand} />
        </Brand>
        {nameOnCard && <NameOnCard>{nameOnCard}</NameOnCard>}
        <Numbers>XXXX XXXX XXXX {card?.last4}</Numbers>
        <Expiry>
          Expiry: {card?.exp_month}/{card?.exp_year}
        </Expiry>
      </Card>
    </div>
  )
}

const Card = styled.div`
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 16px;
  padding: ${(props) => `${props.theme.spacing[5]} ${props.theme.spacing[4]}`};
  display: block;
  max-width: 300px;
  margin: 0 0 ${(props) => props.theme.spacing[4]};
`

const Brand = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 0 ${(props) => props.theme.spacing[4]};
`

const NameOnCard = styled.span`
  display: block;
  margin: 0;
`

const Numbers = styled.span`
  font-size: 24px;
  display: block;
  margin: 0 0 ${(props) => props.theme.spacing[2]};
`

const Expiry = styled.span`
  margin: 0;
`
